import {
  company as fakerCompany,
  internet,
  lorem,
  name,
  phone,
  random,
} from "faker/locale/en_US";

import { defaultNoteStatuses } from "../../../root/defaultConfiguration";
import { contactGender } from "../../../contacts/contactModel";
import type { Contact } from "../../../types";
import type { Db } from "./types";
import { randomDate, weightedBoolean } from "./utils";

const testContacts = [
  {
    first_name: "Ana",
    last_name: "Paula Silveira",
    gender: "female",
    title: "Diretora Financeira",
    email: "ana.silveira@techsolutions.com.br",
    phone: "(11) 98111-2233",
  },
  {
    first_name: "Carlos",
    last_name: "Eduardo Santos",
    gender: "male",
    title: "Sócio Administrador",
    email: "carlos.santos@mercadocentral.com.br",
    phone: "(31) 98222-3344",
  },
  {
    first_name: "Mariana",
    last_name: "Costa Ferreira",
    gender: "female",
    title: "Gerente Geral",
    email: "mariana.ferreira@silvafilhoscivil.com.br",
    phone: "(41) 98333-4455",
  },
];

export const generateContacts = (db: Db, size = 3): Required<Contact>[] => {
  const nbAvailblePictures = 223;
  let numberOfContacts = 0;

  return Array.from(Array(size).keys()).map((id) => {
    const predefined = testContacts[id % testContacts.length];
    const has_avatar =
      weightedBoolean(25) && numberOfContacts < nbAvailblePictures;
    const gender =
      predefined?.gender || random.arrayElement(contactGender).value;
    const first_name = predefined?.first_name || name.firstName(gender as any);
    const last_name = predefined?.last_name || name.lastName();
    const email_jsonb = [
      {
        email: predefined?.email || internet.email(first_name, last_name),
        type: "Work" as const,
      },
    ];
    const phone_jsonb = [
      {
        number: predefined?.phone || phone.phoneNumber(),
        type: "Work" as const,
      },
    ];
    const avatar = {
      src: has_avatar
        ? "https://marmelab.com/posters/avatar-" +
          (223 - numberOfContacts) +
          ".jpeg"
        : undefined,
    };
    const title = predefined?.title || fakerCompany.bsAdjective();

    if (has_avatar) {
      numberOfContacts++;
    }

    // Vincula diretamente a uma das empresas cadastradas
    const company = db.companies[id % db.companies.length] || db.companies[0];
    company.nb_contacts = (company.nb_contacts ?? 0) + 1;

    const first_seen = randomDate(new Date(company.created_at)).toISOString();
    const last_seen = first_seen;

    return {
      id,
      first_name,
      last_name,
      gender,
      title: title.charAt(0).toUpperCase() + title.substr(1),
      company_id: company.id,
      company_name: company.name,
      email_jsonb,
      phone_jsonb,
      background: lorem.sentence(),
      acquisition: random.arrayElement(["inbound", "outbound"]),
      avatar,
      first_seen: first_seen,
      last_seen: last_seen,
      has_newsletter: weightedBoolean(30),
      status: random.arrayElement(defaultNoteStatuses).value,
      tags: random
        .arrayElements(db.tags, random.arrayElement([0, 0, 0, 1, 1, 2]))
        .map((tag) => tag.id), // finalize
      sales_id: company.sales_id!,
      nb_tasks: 0,
      linkedin_url: null,
    };
  });
};
